import React,{ Component  } from 'react';
import axios from 'axios';
import { API, CLIENT, ASSETS_URL, TONE, MEDIA_TYPE } from '../../_helpers/Constants';
import { Table } from 'react-bootstrap';
import '../../_assets/css/CetakNews.css';

import ReactToPrint from 'react-to-print';

export default class Original extends Component {

    constructor(props){
        super(props);
        this.state = {
           id :  props.id,
           isOri :  props.isOri,
           client : JSON.parse(localStorage.getItem("_profile")),
           data: {},
           imagesLoaded: 0
        }
    }

/*
    componentWillMount = () =>{
        this.getDataNews(this.props.id);
        // this.setState({data : this.props.data});
    }
    ImageHelper(ev){
        var client = JSON.parse(localStorage.getItem('_profile'));
        ev.target.src = ASSETS_URL + "img/logo/" + client.subdomain_logo
      }
    
    
  getDataNews(id){
    var self = this;
    var urls =  API + "news/getdetail?username="+ localStorage.getItem('_username')
      + "&token="+ localStorage.getItem('_token') 
      + "&subdomain_id=" + CLIENT
      + "&id="+ id
      + "&date_from=2017-01-01&date_to=2030-12-31";

  console.log(urls);
  axios({
      method: 'get',
        url: urls,
    }).then(function (response) {
        if(response.data.status == 200){
            self.setState({ data : response.data.data[0]});

           
        }else{
          alert(response.data.message);
        }
    }).catch(function (error) {
         alert("please check your connection");
    });
}
*/

/* <<PRINT MULTI PAGE */
        componentDidMount(){
            this.getDataNews(this.props.id);
        }

        ImageHelper = (ev) => {
            const client = JSON.parse(localStorage.getItem('_profile'));
            ev.target.src = ASSETS_URL + "img/logo/" + client.subdomain_logo;
        }

    getDataNews(id){
        const urls = API + "news/getdetail"
        + "?username=" + localStorage.getItem('_username')
        + "&token=" + localStorage.getItem('_token')
        + "&subdomain_id=" + CLIENT
        + "&id=" + id
        + "&date_from=2017-01-01&date_to=2030-12-31";

        axios.get(urls)
        .then(res => {
            if(res.data.status === 200){
            this.setState({ data: res.data.data[0] });
            }
        })
        .catch(() => alert("please check your connection"));
    }
/* PRINT MULTI PAGE>>*/
     
    render(){        
        const { data } = this.state;

        if (!data) return null;

        // AMBIL FILE YANG ADA ISINYA
        const files = [
            data.berita_file,
            data.berita_file2,
            data.berita_file3,
        ].filter(f => f && f !== '');
        
        return (
            <div style={{ padding: 10 }}>
            {files.map((file, index) => (
            <div key={index} className="print-page">

            {/* HEADER */}
            <div className="print-header">
            <Table bordered={true}>
                        <tr>
                            <td width={50}>Judul</td>
                            <td>{this.state.data.berita_judul}</td>
                            <td rowSpan={7} width={200} style={{alignSelf:"center",textAlign:"center", verticalAlign:"middle"}}>
                                    <img width={150} style={{alignSelf:"center"}} src={ASSETS_URL + "img/logo/" + this.state.client.subdomain_logo } alt="" />
                                     {/* <p>
                Image URL: {ASSETS_URL + "img/logo/" + this.state.client.subdomain_logo}
            </p>  */}
                            </td>
                        </tr>
                        <tr>
                <td>Tanggal </td>
                            <td>{this.state.data.berita_waktu}</td>
                        </tr>
                        <tr>
                            <td>Narasumber</td>
                                <td>{this.state.data.narasumber_nama}</td>
                        </tr>
                        <tr>
                            <td>Nilai</td>
                            <td>{this.state.data.berita_tone == 1 ? 'Positif' : (this.state.data.berita_tone == 0 ? 'Netral' : 'Negatif')}</td>
                        </tr>
                        <tr>
                            <td>Topik</td>
                            <td>{this.state.data.topik_nama}</td>
                        </tr>
                        <tr>
                    <td>Rubrik</td>
                            <td>{this.state.data.rubrikasi_nama}</td>
                        </tr>
                    </Table>
                        
            </div>

            {/* PRINT MULTI PAGE*/}
            <div className="print-image">
            <img
                src={ASSETS_URL + '/img/file_original/' + file}
                onError={this.ImageHelper}
                alt={`File ${index + 1}`}
            />
            </div>

        </div>
        ))}



            </div>
        ); 
    }
  
}

